import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsCarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_car"}/>
}
